<!--AFFICHAGE BLOC beneficiaires -->
<template>
  <v-col md="12" class="pa-3 d-flex flex-column"  v-if="this.condition()" >
    <a class="anchor" id="blocbeneficiaires"></a>
    <v-card elevation="2">
      <v-card-title>
        <v-icon dense left color="deep-purple darken-2"> person </v-icon> Bénéficiaires effectifs</v-card-title
      >
      <v-card-text>
        <v-data-table
            v-if="this.beneficiaires!=null"
          dense
          :headers="headers"
          :items="beneficiaires"
          item-key="adId"
          class="elevation-1"
        >
          <template
            v-for="header in headers.filter((header) =>
              header.hasOwnProperty('formatter')
            )"
            v-slot:[`item.${header.value}`]="{ header, value }"
          >
            {{ header.formatter(value) }}
          </template>
          <template #item.modalite_exercice="{ item }">
            <ul>
              <li v-for="modalite in item.modalite_exercice" :key="modalite">{{modalite}} </li>
            </ul>

          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "beneficiaires",
  props: ["etablissement"],
  components: {},
  computed: {
    beneficiaires: function () {
      return this.condition()
        ? this.$store.getters.getbloc("contact", "donnees","beneficiairesInpi",null,"valeur")
        : {};
    },
    headers() {
      return [
        { text: "Nom", value: "nom", align: "start" },
        {
          text: "Date de naissance",
          value: "date_naissance",
          align: "start",
        },
        {
          text: "Nationalité",
          value: "nationalite",
          align: "start",
        },
          {
          text: "Modalité d'exercicice",
          value: "modalite_exercice",
          align: "start",
        },
      ];
    },
  },

  methods: {

    condition() {
      return this.$store.getters.condition("contact", "donnees","beneficiairesInpi", "valeur"  );
    },

  },
};
</script>
